export const ApplicationViewType = {
    AUTH: 'Auth',
    WEBVIEW: 'Webview',
    EMBEDDED: 'Embedded'
}
